import type { BlockResult } from '@/types/blocker'
import type { Quiz, QuizProgress } from '@/types/quiz'

import type { QuizUiStatus } from '../constants/status'

export type QuizWithListMeta = Quiz & {
  _progress?: QuizProgress
  canRetry: boolean
}

export const quizCanRetry = (
  quiz: Quiz,
  progress?: QuizProgress
): boolean => {
  if (!progress) return true
  if (quiz.repeat_chances <= 0) return true
  return progress.attempts_size < quiz.repeat_chances
}

export const getQuizUiStatus = (
  quiz: QuizWithListMeta,
  blockResult: BlockResult
): QuizUiStatus => {
  if (quiz.active === false) {
    return 'expired'
  }

  if (!blockResult.unlocked) {
    return 'locked'
  }

  const progress = quiz._progress
  const canRetry = quiz.canRetry

  if (
    progress &&
    !canRetry &&
    (progress.finished || progress.finished_percent >= 100)
  ) {
    return 'success'
  }

  if (progress && !canRetry && progress.finished_percent > 0) {
    return 'success'
  }

  if (progress && progress.finished_percent > 0 && progress.finished_percent < 100) {
    return 'progress'
  }

  return 'available'
}

export const getQuizProgressPercent = (
  quiz: QuizWithListMeta,
  uiStatus: QuizUiStatus
): number => {
  if (uiStatus === 'locked' || uiStatus === 'expired') return 0
  if (uiStatus === 'success') return 100

  const raw = quiz._progress?.finished_percent ?? 0
  return Math.min(100, Math.max(0, Math.round(raw)))
}
